import { render, staticRenderFns } from "./SusutainabilityInit.vue?vue&type=template&id=40766f24&scoped=true"
import script from "./SusutainabilityInit.vue?vue&type=script&lang=js"
export * from "./SusutainabilityInit.vue?vue&type=script&lang=js"
import style0 from "./SusutainabilityInit.vue?vue&type=style&index=0&id=40766f24&prod&scoped=true&lang=css"
import style1 from "./SusutainabilityInit.vue?vue&type=style&index=1&id=40766f24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40766f24",
  null
  
)

export default component.exports